module.exports = __webpack_public_path__ + "static/media/jacuzzi.66fc9258.svg";